<template>
  <div class="tw-relative tw-flex-1 tw-z-1">
    <BaseSearchbox
      :id="idSearchBoxWrap"
      :class="[
        'tw-relative tw-h-[44px] tw-rounded-[6px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#ffffff] tw-pt-[10px] tw-pb-[8px] tw-px-[15px]',
      ]"
      :model-value="modelValue"
      :placeholder="getComponentUiText('app-header-search-prompt-1')"
      :input-search="idInputSearch"
      @update:model-value="currentValueSearch"
      @on:focus="onInputFocus"
      @on:blur="onblur"
      @keyup.enter="updateRecentSearch"
    />

    <div v-show="isInputFocused" class="hover-modal">
      <ModalHoverSearchAssessment
        :is-search-modal-assessment="false"
        :search-type-id="SEARCH_TYPE_ID.CL_INPUT"
        :is-vendor-assessment="true"
        @update-current-value-search="recentSearchStateUpdate"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Ref, ref, onUnmounted } from "vue";
import ModalHoverSearchAssessment from "@/components/assessment/modalHoverSearchAssessment.vue";
import store from "@/store";
import { SEARCH_TYPE_ID } from "@/utils/constants";
import BaseSearchbox from "../common/form/baseSearchbox.vue";
import { getComponentUiText } from "@/utils/utilities";
import { debounce } from "lodash";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  initialValueSearch: {
    type: String,
    required: true,
  },
  hintText: {
    type: String,
    required: true,
  },
  idSearchBoxWrap: {
    type: String,
    required: false,
    default: "",
  },
  idInputSearch: {
    type: String,
    required: false,
    default: "",
  },
});

const modelValue: Ref<string> = ref("");
const lastValueSearch = ref("");
let valueSearch = "";

const currentValueSearch = debounce((value: any) => {
  modelValue.value = value;
  updateRecentSearch();
}, 550);

const recentSearchStateUpdate = (value: any) => {
  modelValue.value = value;
  emit("update:modelValue", modelValue.value);
};

const isInputFocused = ref(false);

const onInputFocus = (isFocus = true) => {
  valueSearch = modelValue.value;
  isInputFocused.value = isFocus;
};

const onblur = () => {
  setTimeout(() => {
    onInputFocus(false);
  }, 300);

  if (modelValue.value && modelValue.value !== lastValueSearch.value) {
    updateRecentSearch();
  }
};

const updateRecentSearch = async () => {
  if (valueSearch === modelValue.value) return;

  lastValueSearch.value = modelValue.value;
  emit("update:modelValue", modelValue.value);
  await store.commit("Vendor/SET_RECENT_SEARCH", modelValue.value);
};

onUnmounted(() => {
  window.removeEventListener("click", () => {});
});
</script>

<style scoped lang="scss">
.hover-modal {
  box-shadow:
    rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border-bottom: none;

  position: absolute;
  z-index: 999;
  left: 0px;
  width: 100%;
}
</style>
